export default "__VITE_ASSET__DB0_pW9z__"